import React from 'react';
import MetaTags from 'react-meta-tags';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import './HomeHeaderShop.scss';
import SmartVideo from '../../General/SmartVideo';

import usePageLoadEvent from '../../../CustomHooks/usePageLoadEvent';

import { openNewCircleModal } from '../../../Actions/UIActions';

const HomeHeaderShop = props => {
  const seo_header = 'ShopMy | Curated By the Obsessed, Not the Algorithm.';
  const seo_description = "Shop the recommendations of the world's most trusted tastemakers.";

  usePageLoadEvent('Home - Shop - Page View');

  const clickToShopCurators = () => {
    window.__ADD_EVENT__('Home - Header Actions - Click to Shop Curators');
    props.scrollToNextSection();
  };

  // const clickToCreateAccount = () => {
  //   window.__ADD_EVENT__('Home - Header Actions - Click to Create Account');
  //   props.openAuthModal('apply-select-type');
  // };

  // const clickCreateCircle = () => {
  //   window.__ADD_EVENT__('Home - Header Actions - Click to Create Circle');
  //   props.openNewCircleModal({
  //     params: {
  //       panel: 'intro'
  //     },
  //     source: 'Home Header'
  //   });
  // };

  const videoUrl = isMobile ? 'https://static.shopmy.us/Circles/Home_Shop_Mobile_No_Audio.mp4' : 'https://static.shopmy.us/Home/Home_Shop.mp4';
  const coverImageUrl = isMobile ? 'https://static.shopmy.us/Circles/Home_Shop_Mobile.jpg' : 'https://static.shopmy.us/Home/Home_Shop.jpg';

  return (
    <div className='home-header-shop-outer-container'>
      <MetaTags>
        <title>{seo_header}</title>
        <meta property='og:title' content={seo_header} />
        <meta property='description' content={seo_description} />
        <meta property='og:description' content={seo_description} />
      </MetaTags>
      <SmartVideo
        className='cover-media'
        src={videoUrl}
        poster={coverImageUrl}
        type='video/mp4'
        autoPlay
        loop
        muted
        playsInline
        preload='auto'
        noFadeIn
        showPosterUntilPlaying
        alt='World Leading Curators'
      />
      <div className='home-header-shop-inner-container'>
        <div className='main-container'>
          <div className='title-container'>
            <h1 className='title'>
              Curated by the <i>obsessed</i>,
              <br />
              not the algorithm.
            </h1>
            <h2 className='subtitle'>Shop the recommendations of the world's most trusted curators.</h2>
          </div>
          <div className='actions-container'>
            <div onClick={clickToShopCurators} className='action'>
              Shop Curators
            </div>
            {/* <div onClick={clickToCreateAccount} className='action'>
              Create a Account
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

HomeHeaderShop.propTypes = {
  user: PropTypes.object.isRequired,
  scrollToNextSection: PropTypes.func.isRequired,
  openNewCircleModal: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, { openNewCircleModal })(HomeHeaderShop);
